import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { addCompanyMedia, updateCompanyMedia, deleteCompanyMedia } from "./EmployerMediaAPI"

const initialState = {
  companyMedia: [],
  loading: false,
  error: null,
}

export const addCompanyMediaAsync = createAsyncThunk(
  "companyMedia/add",
  async ({data}, { rejectWithValue }) => {
    try {
      const response = await addCompanyMedia(data)
      if (response.status !== "success") {
        throw new Error(response.message || "Failed to add media")
      }
      return response.data
    } catch (error) {
      return rejectWithValue(error.message)
    }
  }
)

export const updateCompanyMediaAsync = createAsyncThunk(
  "companyMedia/update",
  async ({ uuid, data }, { rejectWithValue }) => {
    try {
      const response = await updateCompanyMedia(uuid, data)
      if (response.status !== "success") {
        throw new Error(response.message || "Failed to update media")
      }
      return response.data
    } catch (error) {
      return rejectWithValue(error.message)
    }
  }
)

export const deleteCompanyMediaAsync = createAsyncThunk(
  "companyMedia/delete",
  async (uuid, { rejectWithValue }) => {
    try {
      const response = await deleteCompanyMedia(uuid)
      if (response.status !== "success") {
        throw new Error(response.message || "Failed to delete media")
      }
      return uuid
    } catch (error) {
      return rejectWithValue(error.message)
    }
  }
)

const CompanyMediaSlice = createSlice({
  name: "companyMedia",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(addCompanyMediaAsync.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(addCompanyMediaAsync.fulfilled, (state, action) => {
        state.loading = false
        state.companyMedia.push(action.payload)
      })
      .addCase(addCompanyMediaAsync.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })
      .addCase(updateCompanyMediaAsync.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(updateCompanyMediaAsync.fulfilled, (state, action) => {
        state.loading = false
        const index = state.companyMedia.findIndex((media) => media.uuid === action.payload.uuid)
        if (index !== -1) {
          state.companyMedia[index] = action.payload
        }
      })
      .addCase(updateCompanyMediaAsync.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })
      .addCase(deleteCompanyMediaAsync.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(deleteCompanyMediaAsync.fulfilled, (state, action) => {
        state.loading = false
        state.companyMedia = state.companyMedia.filter((media) => media.uuid !== action.payload)
      })
      .addCase(deleteCompanyMediaAsync.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })
  },
})

export const selectCompanyMedia = (state) => state.companyMedia.companyMedia

export default CompanyMediaSlice.reducer